import { useState, useEffect } from 'react'
import { Spinner } from '@heroui/react'
import { useAuthStore } from '../../../store/useAuthStore'
import { checkSessionExpired } from '../../../api/client'
import { ChartLoginPlaceholder, useChartHidden } from './ChartAuthGate'
import { ChartDownloadButton } from './ChartDownloadButton'

// Statický obrázek grafu — fetch přes fetch() s Bearer hlavičkou (img src neumí custom hlavičky),
// blob se převede na object URL. Sdíleno mezi GrafView/HlyGrafView/DlyGrafView.
export function ChartImage({ url }) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [blobUrl, setBlobUrl] = useState(null)
  const token = useAuthStore(s => s.token)
  const chartHidden = useChartHidden()

  useEffect(() => {
    if (chartHidden) return
    setLoading(true)
    setError(false)
    setBlobUrl(prev => { if (prev) URL.revokeObjectURL(prev); return null })

    const headers = token ? { Authorization: `Bearer ${token}` } : {}
    fetch(url, { headers })
      .then(res => {
        if (!res.ok) { checkSessionExpired(res); throw new Error(`HTTP ${res.status}`) }
        return res.blob()
      })
      .then(blob => {
        const objectUrl = URL.createObjectURL(blob)
        setBlobUrl(objectUrl)
        setLoading(false)
      })
      .catch(e => {
        console.error('[ChartImage] Chyba načítání grafu:', url, e)
        setLoading(false)
        setError(true)
      })

    return () => {}
  }, [url, token, chartHidden])

  useEffect(() => {
    return () => { if (blobUrl) URL.revokeObjectURL(blobUrl) }
  }, [blobUrl])

  if (chartHidden) return <ChartLoginPlaceholder />

  // Formát z URL (&format=png|jpg|svg) — pro příponu stahovaného souboru
  const ext = (url.match(/[?&]format=([a-z]+)/i)?.[1] || 'png').toLowerCase()

  return (
    <div className="relative inline-block">
      {loading && !error && (
        <div className="flex items-center gap-2 text-sm text-gray-500 py-4">
          <Spinner size="sm" /> Načítání grafu…
        </div>
      )}
      {error && (
        <p className="text-red-500 text-sm py-4">Chyba při načítání grafu</p>
      )}
      {blobUrl && (
        <>
          <img src={blobUrl} alt="Graf" className="max-w-full" />
          <ChartDownloadButton href={blobUrl} ext={ext} />
        </>
      )}
    </div>
  )
}
